define('viewModels/QueuesSelectView',[
    'jquery',
    'lib/lodash4',
    'lib/knockout',
    'lib/bluebird',
    'models/Queue',
    'services/divisionService',
    'services/queuesService',
    'services/userService',
    'services/routeService',
    'services/toastService',
    'services/authService',
    'services/navHelper',
    'viewModels/ViewModel',
    'util/errorCallbackFactory'
], function (
    $,
    _,
    ko,
    Promise,
    Queue,
    divisionService,
    queuesService,
    userService,
    routeService,
    toasts,
    authService,
    navHelper,
    ViewModel,
    errorCallbackFactory
) {
    'use strict';

    var QueuesSelectView = ViewModel.extend(function () {

        // ===============================================================================
        // Private API
        // ===============================================================================

        var self = this;

        var filterValue = "";

        var loadQueues = function () {
            // ENGAGEUI-1348 - support more than 100 queues
            // we should remove the joined flag and manually split because it's more performant for the backend.

            return queuesService.getMyQueues({ pageSize: 500, pageNumber: 1})
                .then(function (response) {
                    var selected = [];
                    var available = [];
                    var divisionsEnabled = self.divisionsEnabled();
                    var divisionIds = self.divisionIds;

                    if (response && response.entities) {
                        _.each(response.entities, function (queue) {
                            if (divisionsEnabled && divisionIds && queue.division && queue.division.id) {
                                queue.disabled = !_.includes(divisionIds, queue.division.id);
                            }
                            if (queue.joined) {
                                selected.push(new Queue(queue));
                            } else {
                                available.push(new Queue(queue));
                            }
                        });
                    }

                    selected = _.sortBy(selected, function (queue) { return queue.name; });
                    available = _.sortBy(available, function (queue) { return queue.name; });
                    self.totalCurrentItems(selected.length);
                    self.selectedList(selected);
                    // Need to store this for reference when filtering below
                    self.allAvailableQueues = _.clone(available);
                    self.availableList(available);
                });
        };

        // ===============================================================================
        // Public API
        // ===============================================================================

        self.divisionsEnabled = ko.observable(false);

        self.divisionIds = [];

        self.selectedList = ko.observableArray();

        self.availableList = ko.observableArray();

        self.allAvailableQueues = ko.observableArray();

        self.toggledOptions = ko.observableArray();

        self.totalCurrentItems = ko.observable(0);

        self.isLoading = ko.observable(false);

        self.isUpdatingQueues = ko.observable(false);

        self.submit = function(){
            if(self.toggledOptions().length > 0){

                var queuesToUpdate = [];

                _.each(self.toggledOptions(), function(queue){
                    queue.joined(!queue.joined());
                    queuesToUpdate.push(_.pick(queue.unwrap(), 'id', 'joined'));
                });

                self.isUpdatingQueues(true);

                queuesService.updateUserJoinedQueues(userService.currentUser().id, queuesToUpdate)
                    .then(function(){
                        toasts.notifyMessage("queuesSelect.joinQueues.success.title", {
                            bodyMessageKey: 'queuesSelect.joinQueues.success.body',
                        });
                        routeService.back();
                    })
                    .catch(errorCallbackFactory.createCallback({
                        "namespace": "queuesSelect.joinQueues"
                    }))
                    .finally(function(){
                        self.isUpdatingQueues(false);
                    });

            } else {
                toasts.notifyMessage("queuesSelect.joinQueues.success.title", {
                    bodyMessageKey: 'queuesSelect.joinQueues.noChange.body',
                });
                routeService.back();
            }

        };

        self.cancel = function(){
            routeService.back();
        };

        self.filter = _.throttle(function (value) {
            filterValue = value.toLowerCase();
            var filtered = _.filter(self.allAvailableQueues, function (queue) {
                return queue.name().toLowerCase().indexOf(filterValue) > -1;
            });
            self.availableList(filtered);
        }, 200);

        // ===============================================================================
        // Computeds & Subscriptions
        // ===============================================================================

        // Load queues when view initially loads.

        self.computed(function(){

            if(userService.currentUser() && userService.currentUser().id){

                if (!authService.hasAuthorization({ all: ['perm:routing:queue:join'], ignoreDivisions: true })) {
                    navHelper.redirectTo('');
                }

                self.isLoading(true);
                self.divisionsEnabled(true);

                divisionService.getDivisionsPermitted('routing:queue:join').then(function (results) {
                    self.divisionIds = _.map(results, 'id');
                }).finally(function () {
                    loadQueues()
                        .catch(errorCallbackFactory.createCallback({
                            "namespace": "queuesSelect.setQueues"
                        }))
                        .finally(function(){
                            self.isLoading(false);
                        });
                });
            }

        });

    });

    return QueuesSelectView;

});
